export interface MiscState {}

export const defaultMiscState: MiscState = {};
